// extracted by mini-css-extract-plugin
export default {"aiSummary":"P4SPLY3reW99vD0051Bg"};